import { Model, belongsTo, hasMany, _utilsInflectorCamelize as camelize } from "miragejs";
import { isInterfaceType, isUnionType, isObjectType } from "graphql";
import { isRelayType } from "../relay-pagination-mjs";
import { unwrapType } from "../utils-mjs";
var ASSOCIATION_TYPE_CHECKS = [isInterfaceType, isObjectType, isUnionType];

function isAssociationType(type) {
  return ASSOCIATION_TYPE_CHECKS.find(function (checkType) {
    return checkType(type);
  });
}

function createAssociationForFields(fields) {
  return function (associations, fieldName) {
    var fieldType = fields[fieldName].type;

    var _unwrapType = unwrapType(fieldType, {
      considerRelay: true
    }),
        isList = _unwrapType.isList,
        unwrappedType = _unwrapType.type;

    if (isAssociationType(unwrappedType)) {
      var associationName = camelize(unwrappedType.name);
      var options = {
        polymorphic: isInterfaceType(unwrappedType) || isUnionType(unwrappedType)
      };
      associations.push({
        name: associationName,
        fieldName: fieldName,
        type: isList ? "hasMany" : "belongsTo",
        options: options
      });
    }

    return associations;
  };
}

function createAssociations(type) {
  var fields = type.getFields();
  return Object.keys(fields).reduce(createAssociationForFields(fields), []);
}

function createModel(type) {
  return {
    name: type.name,
    camelizedName: camelize(type.name),
    associations: createAssociations(type)
  };
}

function shouldCreateModel(type) {
  return isObjectType(type) && !isRelayType(type) && !type.name.startsWith("__");
}

function shouldRegisterModel(mirageSchema, name) {
  return !mirageSchema.hasModelForModelName(name);
}

function createAssociationOptions(model) {
  return model.associations.reduce(function (options, association) {
    options[association.fieldName] = association.type === "hasMany" ? hasMany(association.name, association.options) : belongsTo(association.name, association.options);
    return options;
  }, {});
}

function registerModel(mirageSchema, model) {
  var options = createAssociationOptions(model);
  mirageSchema.registerModel(model.name, Model.extend(options));
}

export function createModels(_ref) {
  var graphQLSchema = _ref.graphQLSchema;
  var graphQLSchemaQueryTypes = [graphQLSchema.getMutationType(), graphQLSchema.getQueryType(), graphQLSchema.getSubscriptionType()];
  var typeMap = graphQLSchema.getTypeMap();
  return Object.keys(typeMap).reduce(function (models, typeName) {
    var _unwrapType2 = unwrapType(typeMap[typeName]),
        type = _unwrapType2.type;

    var isQueryType = graphQLSchemaQueryTypes.includes(type);

    if (shouldCreateModel(type) && !isQueryType) {
      models.push(createModel(type));
    }

    return models;
  }, []);
}
export function ensureModels(_ref2) {
  var graphQLSchema = _ref2.graphQLSchema,
      mirageSchema = _ref2.mirageSchema;
  var models = createModels({
    graphQLSchema: graphQLSchema
  });
  models.forEach(function (model) {
    if (shouldRegisterModel(mirageSchema, model.name)) {
      registerModel(mirageSchema, model);
    }
  });
}
